/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { CostCenterFinderListItem, updatePrivilegedControls } from '@gh/builder-shared';
import {
  OfficeMeasurement,
  OfficeMeasurementDefault,
  PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT,
} from '@gh/builder-shared-data';
import { ContextRoute, getContextRouteInitData } from '@gh/common-internal-shared';
import { EnumDictionary } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent } from '@gh/core-ui';
import { assign, range } from 'lodash';
import { SystemVarsEstimatingBusinessService } from '../../../resources/system-vars-estimating-business.service';
import { SystemVarsEstimatingCommonSubTabFormState } from './system-vars-estimating-common-subtab.form.service';

const DAYS_OF_MONTH = range(1, 32); // tslint:disable-line:no-magic-numbers

@Component({
  selector: 'gh-system-vars-estimating-common-subtab',
  template: require('./system-vars-estimating-common-subtab.component.html'),
  styles: [require('./system-vars-estimating-common-subtab.component.scss')],
})
export class SystemVarsEstimatingCommonSubTabComponent implements OnInit {
  officeMeasurement: EnumDictionary<OfficeMeasurement>;
  officeMeasurementDefault: Hash<EnumDictionary<OfficeMeasurementDefault>>;
  days: any = DAYS_OF_MONTH;
  costCenter?: CostCenterFinderListItem;
  autoPublish: boolean = false;

  constructor(private route: ContextRoute,
              public form: SystemVarsEstimatingCommonSubTabFormState,
              private businessService: SystemVarsEstimatingBusinessService) {
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }

  onPrivilegedTokenReceivedMeasurement(): void {
    updatePrivilegedControls(this.form, PRIVILEGED_EP_SYS_VARS_ESTIMATING_MEASUREMENT);
  }

  onMeasurementScaleChanged(): void {
    this.form.resetMeasurementDefault();
  }

  loadPriceBook($event: AutocompleteLoadMoreEvent): void {
    $event.load(this.businessService.loadPriceBook($event.query));
  }

  loadHousePlan($event: AutocompleteLoadMoreEvent): void {
    $event.load(this.businessService.loadHousePlan($event.query));
  }
}
